import { useIntl } from 'react-intl';

import { commonMessages } from 'src/utils/messages';

type FormattedMinutesStatProps = {
    totalMinutes?: number | null;
};

const FormattedTimeStat = ({ totalMinutes }: FormattedMinutesStatProps) => {
    const { formatMessage } = useIntl();

    if (!totalMinutes) return '-';

    if (totalMinutes < 60) {
        return formatMessage(commonMessages.minutes, { value: totalMinutes });
    }

    const totalHours = Math.floor(totalMinutes / 60);

    if (totalHours < 24) {
        const minutes = totalMinutes % 60;

        if (minutes === 0) {
            return formatMessage(commonMessages.hours, { value: totalHours });
        }

        return `${formatMessage(commonMessages.hours, { value: totalHours })} ${formatMessage(commonMessages.minutes, { value: minutes })}`;
    }

    const days = Math.floor(totalHours / 24);
    const remainingHours = totalHours % 24;
    const remainingMinutes = totalMinutes % 60;

    let result = formatMessage(commonMessages.days, { value: days });

    if (remainingHours > 0) {
        result += ` ${formatMessage(commonMessages.hours, { value: remainingHours })}`;
    }

    if (remainingMinutes > 0) {
        result += ` ${formatMessage(commonMessages.minutes, { value: remainingMinutes })}`;
    }

    return result;
};

export default FormattedTimeStat;
